export default "/assets/images/mila-with-dimensions.webp?f1802a778ec5af3092e38271cf9056ce";